import React from 'react';
import '../../../css/characterView.css';
import StatLine from './StatLine';
import Powers from './Powers';
import columns from '../../../json/characterItemColumns.json';

import DynamicTable from '../../../../../core/web/js/table/DynamicTable';

function CharacterView(props){
  const data = props.data;
  const rows = []

  for(let i = 0; i < data.gearSlots; i++){
    rows.push({"number":i+1});
  }

  const renderer = {
    "number":_renderNumber,
    "notes":_renderNotes,
    "name":_renderName
  };

  return (
    <div className="characterView">
      <div className="header">
        <span className="characterName">{props.title} {data.name}</span>, {data.background} Level: {data.level}
      </div>
      <div className="content">
        <StatLine stats={data} />

        <h3>Items</h3>
        <DynamicTable
          columns={columns}
          rows={rows}
          render={renderer}
        />

      <h3>Powers</h3>
        <Powers data={data.powers} />
      </div>
    </div>
  );
}

function _renderNumber(data, row){
  return (<div className="number">{data}</div>);
}

function _renderNotes(data, row){
  return (<div className="notes"></div>);
}

function _renderName(data, row){
  return (<div className="name"></div>);
}

export default CharacterView;
